import { rem } from 'polished'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(16)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} ${rem(12)} ${rem(20)} ${rem(40)};
  }
`

interface Props {
  className?: string
  label: string
}

function TimelineItemPlaceholder({ className, label }: Props) {
  return (
    <Container className={className}>
      <BodyText colour="neutral-four" variant="large">
        {label}
      </BodyText>
    </Container>
  )
}

export default TimelineItemPlaceholder
